import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import {
  WarningItem,
  WarningSummary,
} from '@texas/components/shared/WarningSummary';

interface Props {
  warnings: WarningItem[];
  onNavigate: (warning: WarningItem) => void;
}

export function ArticleWarningSummary({ warnings, onNavigate }: Props) {
  const { t } = useTranslation();
  return (
    <Box flexShrink={0} maxH={{ lg: '40dvh' }} overflowY={{ lg: 'auto' }}>
      <WarningSummary
        warnings={warnings}
        onNavigate={onNavigate}
        title={t('article.create.requiredFields')}
        borderRadius={0}
        borderWidth="1px"
        borderColor="articleManagement.border"
        px={6}
        py={5}
      />
    </Box>
  );
}
